import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Select from "react-select";
import { masterDataActions } from "../../../actions/masterData.action";
const ReactSelect = ({
  field,
  form,
  options,
  isMulti = false,
  placeholder = "Select",
  designationOption,
  selectedDesignation,
  setselectedDesignation
}) => {
  const [query, setQuery] = useState("");
  const [designationChanged, setdesignationChanged] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if(field.name == 'designation' && field.value !== ''){
      setdesignationChanged(field?.value)
    }
  }, [selectedDesignation])
  

  function onChange(option) {
    form.setFieldValue(
      field.name,
      option ? option.map((item) => item.value) : []
    );

  }
  function selectChnage(option) {
    form.setFieldValue(field.name, option.value)
    if (field.name === "department") {
      dispatch(masterDataActions.getDesignationBydepartment(option.id))
      form.setFieldValue("designation","");
    }
    if(field.name == 'designation' && setselectedDesignation){
      setselectedDesignation(option.value)
    }
  }

  const getValue = () => {
    if (options) {
      return isMulti
        ? options.filter((option) => field.value.indexOf(option.value) >= 0)
        : options.find((option) => option.value === field.value);
    } else {
      return isMulti ? [] : "";
    }
  };

  useEffect(() => {
    if(form?.values?.designation == ""){
      setdesignationChanged(null)
    }

  },[form?.values])
  
  if (!isMulti) {
    return (
      <Select
        options={options}
        name={field.name}
        value={
          field.name === "designation" ? 
          designationChanged && options ? options.find((option) => option.value === field.value)   : null
          :options ? options.find((option) => option.value === field.value) : null
        }
        onChange={selectChnage}
        onBlur={field.onBlur}
        placeholder={placeholder}
        onInputChange={(value) => setQuery(value)}
      />
    );
  } else {
    return (
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        name={field.name}
        value={getValue()}
        onChange={onChange}
        onInputChange={(value) => setQuery(value)}
        options={options}
        isMulti={true}
        placeholder={placeholder}
      />
    );
  }
};

export default ReactSelect;
